import { ajax } from '@/plugins/ajax'

export default {
  namespaced: true,
  state: {
    list: []
  },
  getters: {
    list: (state) => state.list,
  },
  actions: {
    fetchMenusSearch({ commit, dispatch }, name) {
      return new Promise((resolve, reject) => {
        ajax.get('CMS/api/MenusQuery/0?name=' + name +'&Take=200').then(r => {
          resolve(r.data);
        }).catch(e => {
          reject(e.response.data)
        });
      })
    },
    create({ commit, dispatch }, model) {
      return ajax.post('CMS/api/Menus', model).then(r => {
      })
    },
    remove({ commit, dispatch }, id) {
      return ajax.delete('CMS/api/Menus', { data: { "id": id } }, { headers: { 'Content-Type': 'application/json' } }).then(r => {
      })
    },
    update({ commit, dispatch }, model) {
      return ajax.put('CMS/api/Menus', model).then(r => {
      })
    },
    assignProductToMenu({ commit, dispatch }, model) {
      return ajax.post('CMS/api/MenuProducts', model).then(r => {
      })
    },
    unassignProductFromMenu({ commit, dispatch }, { id, productId }) {
      return new Promise((resolve, reject) => {
        ajax.delete('CMS/api/MenuProducts', { data: { "id": id, "productId": productId } }, { headers: { 'Content-Type': 'application/json' } }).then(r => {
          resolve(r.data);
        }).catch(e => {
          reject(e.response.data)
        });
      })
    },
  },
  mutations: {
    setList(state, data) {
      state.list = data;
    }
  }
}
